// import axios from 'axios'
import Vue from 'vue'

const ComponentNotificationServiceHelper = {
  methods: {
    /**
     * @param {Object} notify
     * @return {Object}
     */
    showContentMessage(notify) {
      const { id, datos, ruta_cliente, ruta_servidor } = notify
      const formatIMG = ['png', 'jpg', 'jpeg']

      try {
        let route = {}
        if (this.checkVariable(ruta_cliente)) {
          route = JSON.parse(ruta_cliente)
        }
        const result = JSON.parse(datos)
        if (this.isArray(result)) {
          const temp = []
          result.forEach(element => {
            let sw = false
            let index = 0
            while (index < formatIMG.length && sw === false) {
              if (this.endsWith(element, formatIMG[index]) === true) {
                sw = true
                temp.push(this.renderUrl(element))
              }

              index++
            }
          })

          return { id, tag: 'img', value: temp, ...route, ruta_servidor }
        }

        return { id, tag: 'span', value: datos, ruta_servidor }
      } catch (e) {
        return { id, tag: 'span', value: datos, ruta_servidor }
      }
    },
  },
}

const Component = Vue.extend({
  name: 'new-notification-service-helper',
  mixins: [ComponentNotificationServiceHelper],
})

export default Component
